import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Typography,
  styled,
} from "@mui/material";
import { IEmpresaTarefaGatilho } from "services/modules/tarefas";

// ============================================
// STYLED COMPONENTS - Conforme Mockup
// ============================================

const DialogTitleStyled = styled(DialogTitle)(({ theme }) => ({
  color: "#3C90AD",
  fontWeight: 600,
  fontSize: "1.1rem",
  padding: theme.spacing(2, 3),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const DialogContentStyled = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(3),
  minWidth: 400,
}));

const DescriptionText = styled(Typography)(({ theme }) => ({
  color: "#666",
  fontSize: "0.95rem",
  marginBottom: theme.spacing(2),
  lineHeight: 1.6,
}));

const SubtarefasList = styled(List)(({ theme }) => ({
  backgroundColor: "#f9f9f9",
  borderRadius: 4,
  padding: theme.spacing(1, 0),
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

const SubtarefaItem = styled(ListItem)(({ theme }) => ({
  padding: theme.spacing(1, 2),
  "&:not(:last-child)": {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));

const SubtarefaNumber = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: "#3C90AD",
  marginRight: theme.spacing(1),
  minWidth: 20,
}));

const DialogActionsStyled = styled(DialogActions)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  borderTop: `1px solid ${theme.palette.divider}`,
  gap: theme.spacing(1),
}));

const ButtonNao = styled(Button)(({ theme }) => ({
  backgroundColor: "#fff",
  color: "#666",
  border: `1px solid ${theme.palette.divider}`,
  textTransform: "uppercase",
  fontWeight: 600,
  padding: theme.spacing(0.75, 2),
  "&:hover": {
    backgroundColor: "#f5f5f5",
    borderColor: theme.palette.divider,
  },
}));

const ButtonSim = styled(Button)(({ theme }) => ({
  backgroundColor: "#3C90AD",
  color: "#fff",
  textTransform: "uppercase",
  fontWeight: 600,
  padding: theme.spacing(0.75, 2),
  "&:hover": {
    backgroundColor: "#357a94",
  },
}));

// ============================================
// INTERFACES
// ============================================

interface ModalConfirmarSubtarefasProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  gatilho: IEmpresaTarefaGatilho | null;
}

// ============================================
// COMPONENTE
// ============================================

export const ModalConfirmarSubtarefas = ({
  open,
  onClose,
  onConfirm,
  gatilho,
}: ModalConfirmarSubtarefasProps) => {
  if (!gatilho || !gatilho.subtarefas || gatilho.subtarefas.length === 0) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitleStyled>
        Criar sub-tarefas
      </DialogTitleStyled>

      <DialogContentStyled>
        <DescriptionText>
          Para tarefas do tipo cadastro/edição de tipologias há sub-tarefas que precisam ser vinculadas, que são:
        </DescriptionText>

        <SubtarefasList>
          {gatilho.subtarefas.map((subtarefa, index) => (
            <SubtarefaItem key={subtarefa.idEmpresaGatilhoSubtarefa}>
              <SubtarefaNumber>{index + 1}.</SubtarefaNumber>
              <ListItemText
                primary={subtarefa.nome}
                primaryTypographyProps={{
                  style: { fontWeight: 500, color: "#333" },
                }}
              />
            </SubtarefaItem>
          ))}
        </SubtarefasList>

        <Typography
          variant="body2"
          sx={{
            color: "#666",
            fontStyle: "italic",
            textAlign: "center",
            mt: 2,
          }}
        >
          Deseja continuar?
        </Typography>
      </DialogContentStyled>

      <DialogActionsStyled>
        <ButtonNao onClick={onClose}>
          NÃO
        </ButtonNao>
        <ButtonSim onClick={onConfirm}>
          SIM
        </ButtonSim>
      </DialogActionsStyled>
    </Dialog>
  );
};

